{
  "salon-search-form": {
    "buttons": {
      "customize": "Filtre avancé",
      "search": "RECHERCHE"
    },
    "text": {
      "city": "Ville",
      "date": "Date",
      "treatment": "Traitement"
    }
  }
}
